import React from 'react';
import StyleButton from './StyleButton';
import { BoldOutlined, ItalicOutlined, UnderlineOutlined} from '@ant-design/icons';

const INLINE_STYLES = [
    { label: <BoldOutlined />, style: 'BOLD' },
    { label: <ItalicOutlined />, style: 'ITALIC' },
    { label: <UnderlineOutlined />, style: 'UNDERLINE' }
];

const InlineStyleControls = ( { editorState, onToggle } ) => {
    let currentStyle = editorState.getCurrentInlineStyle();
    return (
        <div className="rte-control-group">
            {
                INLINE_STYLES.map( type =>
                    <StyleButton
                        key={ type.style }
                        active={ currentStyle.has( type.style ) }
                        label={ type.label }
                        onToggle={ onToggle }
                        style={ type.style }
                    />
                )
            }
        </div>
    );
};

export default InlineStyleControls;